import type { NavigateFunction } from "react-router";

export type ThunkContext = {
  navigate: NavigateFunction;
};

/**
 * Statisk kontekst-objekt som skal sendes som "extraArg" for redux-thunk-middlewaren.
 * Dette objektet må kun muteres, ikke erstattes, da en ny objekt-referanse vil kreve en ny redux store.
 */
export const THUNK_CONTEXT: ThunkContext = {
  navigate: () => console.log("navigate not set yet"),
};
